import React, { FC, ReactNode, useEffect } from 'react';
import {
  Box,
  Grid,
  Pagination,
} from '@mui/material';

import { usePagination } from '@cvt/hooks/usePagination';
import { MessageFeedbackView } from '@cvt/components/MessageFeedbackView';
import { DEFAULT_QUERY_LIMIT } from '@cvt/helpers/query';

import { useStories } from '../hooks/useStories';


interface ViewProps {
  filters?: Stories.GetListParams;
  renderItem: (story: Stories.Story) => ReactNode;
  onMetadataChange: (metadata: CVT.Query.Metadata) => void
}

export const StoryList: FC<ViewProps> = ({ filters = {}, renderItem, onMetadataChange }) => {
  const { totalPages, setCount, page, setPage, limit, offset } = usePagination(filters.limit || DEFAULT_QUERY_LIMIT);

  const { absoluteTotal, count, stories, status } = useStories({
    ...filters,
    offset,
    limit,
  });

  useEffect(() => {
    if (status === 'success') {
      setCount(count);
    }
  }, [status, setCount, count]);

  useEffect(() => {
    onMetadataChange({ absoluteTotal, count });
  }, [absoluteTotal, count, onMetadataChange]);

  return (
    <React.Fragment>
      {status === 'error' && (
        <MessageFeedbackView height="100%"/>
      )}
      {status === 'success' && (
        <React.Fragment>
          {stories.length === 0 && (
            <MessageFeedbackView height={400} message="No Stories"/>
          )}
          {stories.length > 0 && (
            <>
              <Grid container spacing={2}>
                {stories.map(story => (
                  <Grid size={{ xs: 12, sm: 6, md: 4 }} key={story.id}>
                    {renderItem(story)}
                  </Grid>
                ))}
              </Grid>
              {count > limit && (
                <Box display="flex" width="100%" p={2} mt="auto" justifyContent="center">
                  <Pagination
                    count={totalPages}
                    page={page}
                    onChange={(event, value) => setPage(value)}
                    showFirstButton={page !== 1}
                    showLastButton={page !== totalPages}
                  />
                </Box>
              )}
            </>
          )}
        </React.Fragment>
      )}
    </React.Fragment>
  );
};
